import ArrowRight from './ArrowRight'

export default ArrowRight
// eslint-disable-next-line import/export
export * from './ArrowRight'
